// Adds functionality to current form directives to broadcast event when form submitted state changes

(function (angular) {
    'use strict';

    formDirective('form', 'E');
    formDirective('ngForm', 'EAC');

    function formDirective(name, restrict) {
        angular.module('aprima-core-ui').directive(name, [
            function() {
                return {
                    restrict: restrict,
                    require: 'form',
                    link: {
                        pre: function preLink(scope, element, attrs, formCtrl) {

                            // when $submitted is set then broadcast an event down the scope
                            var setSubmitted = formCtrl.$setSubmitted;
                            formCtrl.$setSubmitted = function formSetSubmitted() {
                                setSubmitted.apply(formCtrl, arguments);
                                scope.$broadcast('ap:form:submitted');
                            };
                        }
                    }
                };
            }
        ]);
    }
})(angular);
